export var isScriptExist = function (match) {
    var scripts = document.getElementsByTagName('script');
    /* tslint:disable-next-line prefer-for-of */
    for (var i = 0; i < scripts.length; i++) {
        var src = scripts[i].src;
        if (src && src.includes(match)) {
            return true;
        }
    }
    return false;
};
export var insertScript = function (url) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.async = true;
        script.addEventListener('load', resolve);
        script.addEventListener('error', reject);
        script.addEventListener('abort', reject);
        document.body.appendChild(script);
    });
};
